// src/lib/supabase.ts
import { createClient } from "@supabase/supabase-js";
import { runtimeEnvironment } from "./runtimeEnvironment";

const supabaseUrl = runtimeEnvironment.supabaseUrl;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
